import React, { useEffect } from "react";
import "./Home.css";
import Services from "./components/Services/Services";
import TournoisListe from "./components/TournoisListe/TournoisListe";
import { useDispatch } from "react-redux";
import { getTournaments } from "../../../Store/tournametsSlice";
import { getPacks } from "../../../Store/packSlice";
import Packs from "./components/Packs/Packs";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getTournaments());
    dispatch(getPacks());
  }, []);

  return (
    <>
      {/* Hero */}
      <div className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Rejoignez-nous pour une expérience de jeu inoubliable.
          </h1>
          <button className="hero-cta" onClick={() => navigate("/reservation")}>
            Réserve ton terrain en ligne
          </button>
        </div>
      </div>

      {/* Tournaments */}
      <section className="home-section">
        <div className="home-section-inner">
          <div className="section-header">
            <h2 className="section-title">Les Triomphes Récents</h2>
            <p className="section-subtitle">Retour sur nos derniers tournois</p>
            <div className="section-divider" />
          </div>
          <TournoisListe />
        </div>
      </section>

      {/* Packs */}
      <section className="home-section home-section--tinted">
        <div className="home-section-inner">
          <div className="section-header">
            <h2 className="section-title">Économisez en Jouant</h2>
            <p className="section-subtitle">Découvrez nos packs de jetons</p>
            <div className="section-divider" />
          </div>
          <Packs />
        </div>
      </section>

      {/* Services */}
      <section className="home-section">
        <div className="home-section-inner">
          <div className="section-header">
            <h2 className="section-title">Découvrez Nos Services</h2>
            <div className="section-divider" />
          </div>
          <Services />
        </div>
      </section>

    </>
  );
};

export default Home;
